let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jkHNB")).then(() => parcelRequire('jxk0c'));